<template>
    <v-dialog
        v-model="dialogLogin"
        width="500"
        persistent
    >
        <v-card>
            <v-col cols="12" class="text-center pt-3">
                <img class="mt-3" alt="Login" src="../../../../assets/grupo-inno.jpg" style="width: 250px;">
            </v-col>
            <div v-if="typeAccess=='login'">
                <v-card-text>
                    <v-col cols="12" class="text-center"><b>{{text}}</b></v-col>
                    <v-form ref="form_login">
                        <v-text-field
                            v-model="user"
                            label="Usuario"
                            prepend-icon="mdi-account"
                            type="text"
                            :rules=requiredRule
                        ></v-text-field>
                        <v-text-field
                            v-model="password"
                            label="Contraseña"
                            prepend-icon="mdi-lock"
                            :type="show ? 'text' : 'password'"
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="show = !show"
                            :rules=requiredRule
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-spacer></v-spacer>
                <v-col  class="text-center">
                    <v-btn 
                        color="primary" 
                        :loading=loadingBtn
                        class="px-5 text-center mx-2"
                        @click="loginClient"
                    >
                        <v-icon>mdi-login-variant</v-icon> INGRESAR
                    </v-btn>
                    <v-btn class="mx-2"
                        @click="$emit('close')"
                    >
                        <v-icon>mdi-cancel</v-icon> CERRAR
                    </v-btn>
                </v-col>
                <v-col>
                    <v-row>
                        <v-col md="6">
                            <v-col class="text-center">
                                <v-btn 
                                    small 
                                    text 
                                    color="primary"
                                    link
                                    @click="typeAccess='create-account'"
                                >
                                    <b><v-icon>mdi-account-key</v-icon> Crear una cuenta</b>
                                </v-btn>
                            </v-col>
                        </v-col>
                        <v-col md="6">
                            <v-col class="text-center">
                                <v-btn 
                                    small 
                                    text 
                                    color="primary"
                                    link
                                    @click="typeAccess ='restart-pass'"
                                >
                                <b><v-icon>mdi-comment-question-outline</v-icon> Olvide mi contraseña</b>
                                </v-btn>
                            </v-col>
                        </v-col>
                    </v-row>
                </v-col>
            </div>
            <div v-if="typeAccess=='create-account'" class="pb-5">
                <v-card-text class="py-0">
                <v-col cols="12" class="text-center" style="font-size: .875rem;"><b>CREAR UNA NUEVA CUENTA</b></v-col>
                <v-stepper v-model="stepNewaccount">
                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-form ref="form_serach_client">
                                <v-col cols="12" class="py-0">
                                    <v-text-field
                                        v-model="userNewAccount"
                                        label="Escriba su identificación"
                                        type="text"
                                        :rules=requiredRule                                   
                                    />
                                </v-col>
                                <v-col  class="text-center">
                                    <v-btn 
                                        
                                        color="primary" 
                                        :loading=loadingBtn
                                        class="px-5 text-center mx-2"
                                        @click="searchIdentification"
                                    >
                                        <v-icon>mdi-skip-next</v-icon> CONTINUAR
                                    </v-btn>
                                    <v-btn class="mx-2" color="warning" 
                                        @click="typeAccess='login'"
                                    >
                                        <v-icon>mdi-keyboard-backspace</v-icon> REGRESAR
                                    </v-btn>
                                </v-col>
                            </v-form>
                        </v-stepper-content>
                    </v-stepper-items>
                    <v-stepper-items>
                        <v-stepper-content step="2">
                            <v-form ref="form_create_account">
                                <v-col>
                                    <v-row>
                                        <transition name="fade">
                                            <v-alert
                                                v-if="userLoginId !=null"
                                                prominent
                                                type="error"
                                                dense
                                            >
                                                <v-row align="center">
                                                    <v-col class="grow">
                                                        La identificación ya tiene un usuario registriado en el sistema, ingrese con su usuario y contraseña o recuepere la misma si no la recuerda.
                                                    </v-col>
                                                </v-row>
                                            </v-alert>   
                                        </transition>       
                                        <v-col cols="12" md="6" class="py-0">
                                            <v-text-field
                                                v-model="userNewAccount"
                                                label="(Usuario)"
                                                type="text"
                                                :rules=requiredRule                                   
                                            />
                                        </v-col>                 
                                        <v-col cols="12" md="6" class="py-0">
                                            <v-text-field
                                                v-model="passwordNewAccount"
                                                label="Contraseña"
                                                :rules=requiredRule
                                                prepend-inner-icon="mdi-key-variant"
                                                :type="show ? 'text' : 'password'"
                                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                @click:append="show = !show"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-0">
                                            <v-text-field
                                                v-model="firstNameNewAccount"
                                                label="Nombres"
                                                type="text"
                                                :rules=requiredRule
                                                prepend-inner-icon="mdi-account-outline"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6" class="py-0">
                                            <v-text-field
                                                v-model="lastNameNewAccount"
                                                label="Apellidos"
                                                type="text"
                                                :rules=requiredRule
                                                prepend-inner-icon="mdi-account-outline"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" class="py-0">
                                            <v-text-field
                                                v-model="emailNewAccount"
                                                label="Correo (se enviará un correo para verificarlo)"
                                                type="email"
                                                :rules=emailRule
                                                prepend-inner-icon="mdi-email"
                                            ></v-text-field>
                                        </v-col>
                                        
                                    </v-row>
                                    <v-col  class="text-center">
                                        <v-btn 
                                            v-if="userLoginId == null && btnNewAccount"
                                            color="primary" 
                                            :loading=loadingBtn
                                            class="px-5 text-center mx-2"
                                            @click="createAccount"
                                        >
                                            <v-icon>mdi-account-plus</v-icon> CREAR CUENTA
                                        </v-btn>
                                        <v-btn class="mx-2" color="warning" 
                                            @click="stepNewaccount=1"
                                        >
                                            <v-icon>mdi-keyboard-backspace</v-icon> REGRESAR
                                        </v-btn>
                                    </v-col>
                                </v-col>
                            </v-form>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
                </v-card-text>
            </div>
            <div v-if="typeAccess=='restart-pass'" >
                <v-card-text class="py-0">
                <v-col cols="12" class="text-center" style="font-size: .875rem;"><b>REINICIE SU CONTRASEÑA CON SU IDENTIFICACIÓN</b></v-col>
                <v-form ref="form_reset_password">
                    <div v-if="typeof validUser != 'undefined'" :style="validUser ? 'color:green' :'color:red'" class="text-center">{{textValid}}</div>
                    <v-col>
                        <v-row>
                            <v-col cols="12" class="py-0">
                                <v-text-field
                                    v-model="userResetPass"
                                    label="Identificación"
                                    type="text"
                                    :rules=requiredRule
                                    prepend-inner-icon="mdi-account-circle"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-col  class="text-center">
                            <v-btn 
                                color="primary" 
                                :loading=loadingBtn
                                class="px-5 text-center mx-2"
                                @click="verifyUser"
                            >
                                <v-icon>mdi-account-plus</v-icon> VERIFICAR
                            </v-btn>
                            <v-btn class="mx-2" color="warning" 
                                @click="typeAccess='login'"
                            >
                                <v-icon>mdi-keyboard-backspace</v-icon> REGRESAR
                            </v-btn>
                        </v-col>
                    </v-col>
                </v-form>
                </v-card-text>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapActions, mapMutations, mapState } from 'vuex'

export default {
    name: 'LoginWebComponent',
    data:()=>({
        stepNewaccount:1,
        show:false,
        user:'',
        userResetPass:null,
        password:'',
        firstNameNewAccount:null,
        lastNameNewAccount:null,
        emailNewAccount:null,
        userNewAccount:null,
        passwordNewAccount:null,
        btnNewAccount:false,
        typeAccess:'login',
        textValid: '',
        partyIdUser:null,
        userLoginId: null,
        validUser:undefined,
        requiredRule:[
            v => !!v || 'El campo es requerido'
        ],
        emailRule:[
            v => !!v || 'El correo es requerido',
            v => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Escriba un correo válido'
        ]
    }),
    props:{

        dialogLogin:{
            type: Boolean,
            default: false
        },

        text:{
            type: String,
            default: 'INICIA SESIÓN PARA ACCEDER A DIVERSOS BENEFICIOS'
        }

    },
    computed:{
        ...mapState(['loadingBtn','shoppingCar'])
    },
    watch:{

        userNewAccount(val){
            this.btnNewAccount=false
        }
    },
    methods: {

        ...mapActions(['loginAction','requestApi','alertNotification']),

        ...mapMutations(['setUrl','setLoadingBtn','setUserVerificated','itemShoppingCar','setSelectedProducts']),

        loginClient(){
            
            if(!this.$refs.form_login.validate())
                return

            this.setUrl('oauth')
    
            this.loginAction({
                user : this.user,
                password: this.password,
            }).then(res =>{
            
                if(res.statusText === "Created" && res.status === 201){

                    this.$emit('close')

                    let user = JSON.parse(localStorage.getItem('user'))
                    let products = []
                   
                    const { lastQuote } = res.data.user
                   
                    //NO TIENE COTIZACIONES ACTIVAS, SE CREA UNA NUEVA CABECERA DE COTIZACION CON LOS ITEMS QUE HALLA AGREGADO
                    if(lastQuote == null){

                        this.setUrl('cotizacion-web')
                        this.requestApi({
                            method: 'POST',
                            data:{
                                partyId: user.party_id,
                                userLoginId : user.user_ligin_id,
                                items: JSON.stringify(this.shoppingCar)
                            }
                        }).then(res=>{

                            localStorage.setItem('quote_id',res.data.detail.quoteId)

                        })

                    }else{ //TIENE UNA COTIZACION ACTIVA

                        localStorage.setItem('quote_id',lastQuote.quote_id)
        
                        //SI TIENE ITEMS EN EL CARRITO SE ACTUALIZAN CON LO QUE TENGA EN EL CARRITO O CREAN LOS ITEMS DE LA COTIZACIÓN EN LA BD 
                        if(this.shoppingCar.length){ //ESTO SE EVALUA PRIMERO YA QUE ES MAS IMPORTANTE LOS PRODUCTOS ACTUALES QUE LO QUE YA ESTABA EN LA BD

                            this.shoppingCar.forEach(e => {
                               
                                let existProduct = lastQuote.products.find(i => i.product_id == e.product_id)
                               
                                //EXISTE EL PRODUCTO EN LA BD Y TAMBIEN EN EL CARRITO AL INICIAR SESION POR LO CUAL SE ACTUALZIA EN LA BD 
                                
                                if(typeof existProduct != 'undefined'){

                                    products.push({
                                        product_id: e.product_id,
                                        images: e.images,
                                        price: parseFloat(e.price),
                                        quantity: e.quantity,
                                        brand_name : e.brand_name,
                                        internal_name : e.internal_name,
                                        tax_value : parseFloat(e.tax_value),
                                        psicotropico: existProduct.psicotropico,
                                        quoteItemSeqId: existProduct.quote_item_seq_id,
                                        inventory: existProduct.inventory,
                                        valor_descuento: isNaN(parseFloat(existProduct.valor_descuento)) ? 0 : parseFloat(existProduct.valor_descuento),
                                        is_promo: isNaN(parseFloat(e.is_promo)) ? 0 : parseFloat(e.is_promo)
                                    })

                                }else{ //SOLO EXISTE EL PRODUCTO EN EL CARRITO POR LO CUAL SE INGRESA EN LA BD
                                   
                                    products.push({
                                        product_id : e.product_id,
                                        images : e.images,
                                        price : parseFloat(e.price),
                                        quantity : e.quantity,
                                        brand_name : e.brand_name,
                                        internal_name : e.internal_name,
                                        tax_value : parseFloat(e.tax_value),
                                        inventory: e.inventory,
                                        valor_descuento: isNaN(parseFloat(e.valor_descuento)) ? 0 : parseFloat(e.valor_descuento),
                                        is_promo: isNaN(parseFloat(e.is_promo)) ? 0 : parseFloat(e.is_promo)
                                    })

                                }
                                
                            })
                          
                            this.setUrl(`cotizacion-web/${lastQuote.quote_id}`)

                            this.requestApi({
                                method: 'PATCH',
                                data:{
                                    items: products,
                                    userLoginId : user.user_ligin_id,
                                }
                            }).then(res => {
                             
                                let returnedProducts=[]

                                res.data.detail.quoteItems.forEach(e => {
                               
                                    let obj ={
                                        product_id : e.product_id,
                                        brand_name: e.marca,
                                        images: e.images,
                                        internal_name: e.item_description,
                                        price : parseFloat(e.quote_unit_price),
                                        psicotropico: e.psicotropico,
                                        quantity : parseFloat(e.quantity),
                                        tax_value : parseFloat(e.pct_impuesto),
                                        quoteItemSeqId: e.quote_item_seq_id,
                                        inventory: e.inventory,
                                        valor_descuento: isNaN(parseFloat(e.valor_descuento)) ? 0 : parseFloat(e.valor_descuento),
                                        is_promo: isNaN(parseFloat(e.is_promo)) ? 0 : parseFloat(e.is_promo)
                                    }

                                    returnedProducts.push(obj)

                                    this.setSelectedProducts(obj)  

                                })

                                console.log('returnedProducts',returnedProducts)
                                this.itemShoppingCar(returnedProducts)

                            })

                        }else if(lastQuote.products.length){ //SI TIENE PRODUCTOS EN LA COTIZACION EN LA BD SE ACTUALIZA EL CARRITO CON ESOS PRODUCTOS QUE NO TIENE EN EL CARRITO

                            products = lastQuote.products.map(e => {
                              
                                let obj =  {
                                    brand_name: e.marca,
                                    images: e.images,
                                    internal_name: e.item_description,
                                    price : parseFloat(e.quote_unit_price),
                                    product_id : e.product_id,
                                    psicotropico: e.psicotropico,
                                    quantity : parseFloat(e.quantity),
                                    tax_value : parseFloat(e.pct_impuesto),
                                    quoteItemSeqId: e.quote_item_seq_id,
                                    inventory: e.inventory,
                                    valor_descuento: isNaN(parseFloat(e.valor_descuento)) ? 0 : parseFloat(e.valor_descuento),
                                    is_promo: isNaN(parseFloat(e.is_promo)) ? 0 : parseFloat(e.is_promo), 
                                }

                                this.setSelectedProducts(obj)

                                return obj

                            })
                           
                            this.itemShoppingCar(products)
                            
                        }

                    }

                }

            })

        },

        createAccount(){

            if(!this.$refs.form_create_account.validate())
                return false

            this.setLoadingBtn()

            this.setUrl('user-login');
            this.requestApi({
                method: 'POST',
                data: {
                    firstName: this.firstNameNewAccount,
                    lastName: this.lastNameNewAccount,
                    email: this.emailNewAccount,
                    user: this.userNewAccount,
                    password: this.passwordNewAccount,
                    partyId: this.partyIdUser,
                   //userLoginId: this.userLoginId
                }

            }).then(res=>{
                console.log(res)
                this.alertNotification({
                    param:{
                        html : res.data.msg
                    }
                })
                this.typeAccess= 'login'
                this.setLoadingBtn()
                this.setUserVerificated(false)
            })

        },

        verifyUser(){

            if(!this.$refs.form_reset_password.validate())
                return false

            this.setLoadingBtn()
            this.setUrl('user-login/1');
            this.requestApi({
                method: 'PATCH',
                data: {
                    userResetPass: this.userResetPass,
                }

            }).then(res=>{

                if(!res.data.verify){
                    this.textValid ='Usuario o identificación no está registrada, por favor cree una nueva cuenta'
                    this.validUser = false
                }else{
                    this.textValid ='Usuario validado, se ha enviado un enlace al siguiente correo para reiniciar su contraseña ' + res.data.billingEmail.info_string
                    this.validUser = true
                }
                console.log(res.data)
                this.setLoadingBtn()
                
            })

        },

        searchIdentification(){

            if(!this.$refs.form_serach_client.validate())
                return false

            this.stepNewaccount=2
            this.setUrl(`buscar-cliente/${this.userNewAccount}`);
            this.overlayReceiver=true

            this.requestApi({
                method: 'GET',
                data: {
                    partyId : ''
                }
            }).then(async res=>{

                console.log(res)                           

                if(res.data.person != null){

                    const {
                        party_id,
                        first_name,
                        last_name, 
                        email,
                        user_login_id
                    } = res.data.person

                    this.firstNameNewAccount = first_name
                    this.lastNameNewAccount = last_name
                    this.emailNewAccount = email != null ? email.info_string : ''
                    this.partyIdUser = party_id
                    this.userLoginId = user_login_id
                                 
                    this.alertNotification({
                        param:{
                            html : 'Persona encontrada'
                        }
                    })
                
                }else{

                    this.firstNameNewAccount = null
                    this.lastNameNewAccount = null
                    this.emailNewAccount = null
                    this.passwordNewAccount = null
                    this.partyIdUser = null
                    this.userLoginId = null

                    this.alertNotification({
                        param:{
                            html : 'Identificación no encontrada, por favor ingrese su datos en los campos requeridos para crear su cuenta',
                            timer: 5000,
                            title: 'Error',
                            icon: 'error',
                            confirmButtonColor: 'red'
                        }
                    })
                    
                }

                this.btnNewAccount =true
                this.overlayReceiver=false
                
            })

        }

    }
}

</script>


<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>